module.exports = __webpack_public_path__ + "static/media/sellIcon.8bee8f69.svg";